export default {
    send: 'Send',
    cancel: 'Cancel',
    placeholder: 'Write a question or suggestion',
    thanks: 'Thank you! Already processing the message',
    requiredField: 'It is necessary to fill in',
};
